/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.themes.donation.create.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.factory.notice',
  'acme.common.factory.gridState',
  'acme.common.factory.gridDefinition',
  'acme.common.service.api',
  'acme.common.service.templates',
  'acme.common.service.themesHelper',
  'acme.common.service.validate',
  'acme.common.service.userPreferences'
])

.controller('ThemesDonationCreateController', [
  '$scope', '$state', '$timeout', '$uibModal', '$filter',
  'TemplatesService', 'NoticeFactory', 'GridStateFactory', 'GridDefinitionFactory', 'ValidateService', 'UserPreferencesService',
  'ApiService', 'ThemesHelperService',
  'ThemesData',
  function(
    $scope, $state, $timeout, $uibModal, $filter,
    TemplatesService, NoticeFactory, GridStateFactory, GridDefinitionFactory, ValidateService, UserPreferencesService,
    ApiService, ThemesHelperService,
    ThemesData
  ) {

    $scope.themesDonationCreate = {

      model: {
        archived: false,
        textVariables: []
      },

      close: false,

      tenant: {},

      notice: new NoticeFactory(),

      modal: {},

      errors: [],

      timeStampDateFormat: UserPreferencesService.getDateFormat('standardDateTime', 'dateFormat'),
      timeStampHourFormat: UserPreferencesService.getDateFormat('standardTime', 'hourFormat'),

      // gridDefinition
      gridState: new GridStateFactory(),
      gridDefinition: new GridDefinitionFactory(),
      viewId: '',
      gridName: $state.current.name+'.grid0',
      optionsOverride: {
        data: 'themesDonationCreate.model.textVariables',
        useAccessibleGrid: true,
        columnDefs: [
            {
              field: 'enabled',
              displayName: 'Enabled',
              width: 50,
              enableHiding: false,
              cellTemplate: '' +
                '<div class="ui-grid-cell-contents text-center" ng-class="col.colIndex()">' +
                  '<label><input type="checkbox" data-ng-model="row.entity.enabled"> <span class="sr-only">Enable or disable {{ row.entity.label }}</span></label>' +
                '</div>'
            },
            {
              field: 'editable',
              displayName: 'Edit',
              width: 60,
              enableHiding: false,
              onCellNavClick: function(row, col) {
                $scope.themesDonationCreate.optionsOverride.appScopeProvider.edit(row.entity);
              },
              cellTemplate: '<div class="ui-grid-cell-contents text-center" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.edit(row.entity)" role="button">Edit<span class="sr-only"> Details for {{ row.entity.name }}</span></a></div>'
            },
            {
              field: 'textVariable',
              displayName: 'Text Variable'
            },
            {
              field: 'label',
              displayName: 'Label'
            },
            {
              field: 'customValue',
              displayName: 'Override Value'
            },
            {
              field: 'themeValue',
              displayName: 'Theme Value',
              visible: false
            },
            {
              field: 'allowMarkup',
              displayName: 'HTML Support',
              visible: false,
              cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><span data-ng-if="row.entity.allowMarkup">Yes</span><span data-ng-if="!row.entity.allowMarkup">No</span></div>',
            },
            {
              field: 'description',
              displayName: 'Description',
              visible: false
            }
        ],
        appScopeProvider: {
          onDataGridPaginate: function(newPageNumber, newPageSize, sortField, sortDirection) {
            $scope.themesDonationCreate.onDataGridPaginate(newPageNumber, newPageSize, sortField, sortDirection);
          },
          onDataGridSortChange: function(grid, columns, page) {
            $scope.themesDonationCreate.onDataGridSortChange(grid, columns, page);
          },
          onDblClick: function (item) {
            $scope.themesDonationCreate.edit(item.entity);
          },
          enableThemeVar: function (item) {
            $scope.themesDonationCreate.enableThemeVar(item);
          },
          edit: function (item) {
            $scope.themesDonationCreate.edit(item);
          }
        },
      },

      init: function() {
        $scope.$emit('Application::contentTitleChange', {
          title: 'Edit Donation Theme Override',
          buttonRight: {
            label: 'Save & Close',
            action: function () {
              $scope.themesDonationCreate.saveAndClose();
            }
          },
          buttonLeft: {
            label: 'Back',
            action: function () {
              $state.go('application.themes.config.donation');
            }
          }
        });

        this.setTheme();
        this.getTenant();

        this.viewId = $state.current.name;
        this.gridDefinition.init(this.gridName, this.optionsOverride, this.viewId, $state.current.data.enablePreferences);

        this.initWatchersAndEvents();
      },

      setTheme: function() {
        if (ThemesData && ThemesData.data.payload) {
          ThemesHelperService.resetModel();
          ThemesHelperService.setModel(ThemesData.data.payload);
        }
      },

      initWatchersAndEvents: function() {
        $scope.$on('$destroy', $scope.$on('DataGrid::UserPreferencesLoaded', this.initData));
      },

      initData: function() {
        var self = $scope.themesDonationCreate,
            props = self.gridDefinition.getGridState();

        self.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
        self.getDonationTheme();
      },

      isNewTheme: function() {
        return ($state.params.id || this.model.id) ? false : true;
      },

      getValidators: function() {
        return [
          {
            field: 'themes-donation-create-meta-name',
            len: {
              message: 'Invalid name',
              test: {
                value: this.model.name
              }
            }
          }
        ];
      },

      validate: function() {
        return ValidateService.validate(this.getValidators());
      },

      processCustomText: function() {
        return (this.model.textVariables.length) ? this.model.textVariables.filter(function(item) {
          return (item.customValue && item.customValue.length);
        }) : [];
      },

      processCustomValue: function() {
        return this.model.textVariables.map(function(item) {
          if (!item.customValue) {
            item.customValue = '';
          }

          if (!item.enabled) {
            item.enabled = 'false';
          }

          return item;
        });
      },

      saveAndClose: function() {
        this.close = true;
        this.save();
      },

      save: function() {
        var self = $scope.themesDonationCreate;

        self.errors = {};
        self.notice.hideSuccessMessages();
        self.notice.hideErrorMessages();

        if (self.validate()) {

          this.model.customText = this.processCustomValue();
          this.model.archived = this.model.archived.toString();

          if (self.isNewTheme()) {
            ApiService.textVariables.override.create(this.model).then(this.success.save, this.error.save);
          } else {
            ApiService.textVariables.override.update(this.model).then(this.success.edit, this.error.edit);
          }
        } else {
          self.errors = ValidateService.getErrorHash();
          self.notice.showErrorMessages([{
            message: 'Please correct the errors below'
          }]);
        }
      },

      edit: function(item) {
        var self = $scope.themesDonationCreate;

        self.modal = $uibModal.open({
            templateUrl: 'views/application/views/themes/donation/modals/editValue/editValue.tpl.html',
            size: 'lg',
            controller: 'ThemesDonationModalsEditValueController',
            resolve: {
                themeItem: function () {
                    return item;
                }
            }
        });
      },

      enableThemeVar: function(item) {
        item.enabled = !item.enabled;
      },

      getTenant: function() {
        ApiService.tenant.view().then(this.success.getTenant, this.error.getTenant);
      },

      getDonationTheme: function() {
        var self = $scope.themesDonationCreate,
            props = {
              id: $state.params.id
            };

        ApiService.textVariables.get({groupId: 6}).then(function(response) {
          self.model.textVariables = response.data.payload.textVariables.sort(function(a,b) {
            var nameA = a.label.toUpperCase(),
                nameB = b.label.toUpperCase();

            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }

            return 0;
          });

          self.model.textVariables.forEach(function(item) {
            item.themeValue = ThemesHelperService.getTextVariable(item.textVariable, '');
          });

          if(!self.isNewTheme()){
            ApiService.textVariables.override.get(props).then(self.success.getDonationTheme, self.error.getDonationTheme);
          } else {
            self.resizeGrid();
          }
        }, self.error.getDonationTheme);
      },

      resizeGrid: function() {
        var self = $scope.themesDonationCreate;

        self.gridDefinition.isLoaded = true;

        $timeout(function() {
          $scope.$broadcast('DataGrid::ResizeGrid', {name: self.gridDefinition.options.gridName, datasetLength: self.model.textVariables.length, totalItems: self.model.textVariables.length});
        }, 10);
      },

      isAriaInvalid: function(name) {
        return ($scope.themesDonationCreate.errors[name] && $scope.themesDonationCreate.errors[name].message) ? true : false;
      },

      success: {
        init: function(response) {},
        getTenant: function(response) {
          var self = $scope.themesDonationCreate;
          self.tenant = response.data.tenant;
          self.tenant.donateURL = self.tenant.consumerPage.replace(/events/gi, 'donate');
          self.tenant.cartURL = self.tenant.consumerPage.replace(/events/gi, 'orders') + '/tickets';
        },

        getDonationTheme: function(response) {
          var self = $scope.themesDonationCreate;
              customText = {},
              currentOverride = response.data.payload;

          self.model.id = currentOverride.id;
          self.model.token = currentOverride.token;
          self.model.name = currentOverride.name;
          self.model.description = currentOverride.description;
          self.model.archived = currentOverride.archived;

          if (currentOverride.updatedOn) {
            self.formattedUpdatedOn = $filter('date')(currentOverride.updatedOn, self.timeStampDateFormat) + ' at ' +  $filter('date')(currentOverride.updatedOn, self.timeStampHourFormat);
          }

          currentOverride.customText.forEach(function(item) {
            customText[item.textVariable] = item;
          });

          self.model.textVariables.forEach(function(item) {
            if (customText.hasOwnProperty(item.textVariable)) {
              item.customValue = customText[item.textVariable].customValue;
              item.enabled = customText[item.textVariable].enabled;
            }
          });

          self.resizeGrid();
        },

        save: function(response) {
          var self = $scope.themesDonationCreate;

          self.errors = {};
          self.notice.hideSuccessMessages();
          self.notice.hideErrorMessages();

          self.notice.showSuccessMessages([{
            message: 'Saved!'
          }]);

          $timeout(function(){
            if (self.close) {
              $state.go('application.themes.config.donation');
            } else {
              $state.go('application.themes.donationCreate', { id: response.data.payload.id });
            }

          }, 2000);
        },

        edit: function() {
          var self = $scope.themesDonationCreate;

          self.errors = {};
          self.notice.hideSuccessMessages();
          self.notice.hideErrorMessages();

          if (self.close) {
            $state.go('application.themes.config.donation');
          } else {
            self.notice.showSuccessMessages([{
              message: 'Saved!'
            }]);

            $timeout(function(){
              self.notice.hideSuccessMessages();
            }, 5000);
          }
        }
      },

      error: {
        init: function(response) {},
        getTenant: function(response) {},
        getDonationTheme: function(response) {
          $scope.themesDonationCreate.notice.showErrorMessages(response.data.error);
        },
        save: function(response) {
          $scope.themesDonationCreate.notice.showErrorMessages(response.data.error);
        },
        edit: function(response) {
          $scope.themesDonationCreate.notice.showErrorMessages(response.data.error);
        }
      },

      onDataGridPaginate: function(newPage, pageSize, sortField, sortDirection) {
        var self = $scope.themesDonationCreate;
        self.gridState.updateGridState(newPage, pageSize);
        if (sortField) {
          self.gridState.updateGridState(null, null, sortField, null);
        }
        if(sortDirection) {
          self.gridState.updateGridState(null, null, null, sortDirection);
        }
        self.getDonationTheme();
      },

      onDataGridSortChange: function(grid, columns, page) {
        var self = $scope.themesDonationCreate, data = columns[0];
        self.gridState.updateGridState(page || null, null, data.field, data.sort.direction);
        self.getDonationTheme();
      },

    };

    $scope.themesDonationCreate.init();

}]);
